<script> 
  export default {
    name: 'FormLabel',
    props: {
      isOptional: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<template>
  <label class="FormLabel">
    <span class="font-medium">
      <slot />
    </span>
    <span v-if="isOptional" class="text-muted ml-2">
      ({{ $t('global.optional') }})
    </span>
  </label>
</template>

<style lang="scss" scoped>
  .FormLabel {
    display: inline-flex;
    align-items: center;
    line-height: 1.25;

    .badge {
      position: static;
    }
    .fa-lg {
      margin-top: -2px;
    }
  }
</style>